import React from 'react';
import PropTypes from 'prop-types';
import * as constand from "../../constant";
import { Link } from 'react-router-dom';


const RegisterWarningComponent = ({ nextStep }) => {
  return (
        <div className="step-minus-1">
          <h3 className="text-center font-semibold m-b-40" id="exampleModalLabel font-medium">
            Please Read: Accessing Kidney Beam <Link to="/" className="close-register orangefont font-qregula">X</Link>
          </h3>
          <div className="row justify-content-center align-items-center">
            <div className="input_section col-md-9 font-qmedium font-14 black-txt mb-0">
              
              <p>Thank you for your interest in signing up for Kidney Beam. Currently we are taking on new patient registrations as below:</p>

              <p><strong>United Kingdom</strong><br/>
              <ul>
              <li>Free access for patients at King's College Hospital London</li>
              <li>Free access if you have been given a promo code by one of our partners</li>
              </ul>
              </p>

              <p><strong>Republic of Ireland</strong><br/>
              Free access for everyone with kidney disease in the Republic of Ireland.</p>

              <p><strong>Research Trials</strong><br/>
              If you are registering as part of a research trial, you will have been given a special code to gain access.</p>

              <p>If you meet one of the criteria outlined above, please continue to sign up for Kidney Beam.</p>
            
              <div className="mt-32 d-flex justify-content-center gap-32">
                <Link to="/" className="btn-purple-inverse btn-wide btn-register-warning-back">Back</Link>
                <button className="bluebtn btn-wide btn-register-warning" onClick={() => nextStep()}>Continue</button>
              </div>
              <div className="max-w-xl font-sans leading-relaxed text-gray-800 m-b-40">
                <p><strong>Not Eligible?</strong><br/></p>
                <p>
                  For those who are not eligible for free access to Kidney Beam, we are compiling a list of requests
                  for support in unfunded areas. This will assist us in knowing where there is demand for the service.
                  Please{" "}
                  <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdynO2vNqu3fp9GsFn3Mcqqwe0ZE47KVsMl6-MkGrTkrc84EQ/viewform"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="new-doc-link"
                  ><strong>add your details here</strong></a>
                  , which will support our application for funding where you are.
                </p>
              </div>
            </div>
          </div>
        </div>
  );
};

RegisterWarningComponent.propTypes = {
  nextStep: PropTypes.func.isRequired
};

export default RegisterWarningComponent; 